import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from 'src/app/services/config.service';

@Injectable({
  providedIn: 'root'
})
export class LabUserService {
  endpoint:any;
  constructor(private http: HttpClient,  private configService: ConfigService) {
    this.endpoint = this.configService.endpoints;
   }

  getUserbyUserId(id) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/User/${id}`);
  }

  saveUser(data) {
    return this.http.post<any>(`${this.endpoint.APIEndpoint}/User`, data);
  }

  updateUser(data) {
    return this.http.put<any>(`${this.endpoint.APIEndpoint}/User`, data);
  }

  resetPassword(data) {
    return this.http.post<any>(`${this.endpoint.LogInAPIEndpoint}/validate/${data}`, null);
  }

  getUserList(clientId, filterModel, customFilter) {
    return `${this.endpoint.APIEndpoint}/user/list/${clientId}?${filterModel.PageSize}&${filterModel.RunCount}&${filterModel.StartPageNo}&${filterModel.SortExpression}&${customFilter}`;
  }

  userDisable(id) {
    return this.http.post<any>(`${this.endpoint.APIEndpoint}/user/${id}/disable`, null);
  }

  userEnable(id) {
    return this.http.post<any>(`${this.endpoint.APIEndpoint}/user/${id}/enable`, null);
  }

  getLabLocation(id, filterModel) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/LabLocation/list/${id}?${filterModel.PageSize}&${filterModel.RunCount}&${filterModel.StartPageNo}&${filterModel.SortExpression}`);
  }

  getClientroles() {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/role/list/clientroles`);
  }

  getAlllocations(clientId, id) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/User/alllocations/${clientId}/${id}`);
  }
}
